import {Popover, PopoverContent, PopoverTrigger} from "../../components/ui/popover";
import {Button} from "../../components/ui/button";
import {ListFilter} from "lucide-react";
import {Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue} from "../../components/ui/select";
import {displaySpellLevel} from "../SpellFormatting";
import {CasterCharacterClasses} from "@/characters/model/CharacterClasses.ts";
import {SCHOOL_COLORS} from "../model/SpellSchools";
import {Separator} from "@/components/ui/separator.tsx";

export function SpellFilter({level, setLevel, clazz, setClazz, school, setSchool, reset, hasFilters}: {
    level: number | null
    setLevel: (value: number | null) => void
    clazz: string
    setClazz: (value: string) => void
    school: string
    setSchool: (value: string) => void
    reset: () => void
    hasFilters: boolean
}) {
    const all = "__all__";
    return <Popover>
        <PopoverTrigger asChild>
            <Button size="icon-sm" variant="outline" className="relative bg-background/30" title="Filtern">
                <ListFilter/>
                {hasFilters &&
                    <span
                        className="absolute top-0.5 right-0.5 size-2 translate-x-2/4 -translate-y-2/4 rounded-full bg-blue-500 "/>
                }
            </Button>
        </PopoverTrigger>
        <PopoverContent align="start" className="flex flex-col gap-2">

            <Select onValueChange={(value) => setLevel(value === all ? null : Number(value))}
                    value={level === null ? all : level.toString()}>
                <SelectTrigger className="w-full" size="sm">
                    <SelectValue placeholder="Stufe"/>
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectItem value={all}>Alle Stufen</SelectItem>
                        {Array.from({length: 10}).map((_, levelOption) =>
                            <SelectItem key={levelOption} value={levelOption.toString()}>
                                {displaySpellLevel(levelOption)}
                            </SelectItem>)}
                    </SelectGroup>
                </SelectContent>
            </Select>

            <Select onValueChange={(value) => setClazz(value === all ? "" : value)} value={clazz || all}>
                <SelectTrigger className="w-full" size="sm">
                    <SelectValue placeholder="Klasse"/>
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectItem value={all}>Alle Klassen</SelectItem>
                        {CasterCharacterClasses.map(clazz =>
                            <SelectItem key={clazz} value={clazz}>{clazz}</SelectItem>)}
                    </SelectGroup>
                </SelectContent>
            </Select>
            <Select onValueChange={(value) => setSchool(value === all ? "" : value)} value={school || all}>
                <SelectTrigger className="w-full" size="sm">
                    <SelectValue placeholder="Zauberschule"/>
                </SelectTrigger>
                <SelectContent>
                    <SelectGroup>
                        <SelectItem value={all}>Alle Zauberschulen</SelectItem>
                        {Object.entries(SCHOOL_COLORS).map(([key, data]) =>
                            <SelectItem key={key} value={key}>{data.label}</SelectItem>)}
                    </SelectGroup>
                </SelectContent>
            </Select>
            <Separator/>
            <div className="flex justify-end">
                <Button size="sm" variant="secondary" onClick={reset}>
                    Filter zurücksetzen
                </Button>
            </div>
        </PopoverContent>
    </Popover>;
}
